import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';

import { UserStateService } from '@core/services/authApiService/user-state-service.service';

const publicPaths = ['/auth/login', '/public-list', '/public-profiles', '/public-profile', '/public-visibility'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userState = inject(UserStateService);
  const localStorage = inject(WA_LOCAL_STORAGE);

  const isPublic = publicPaths.some((path) => req.url.includes(path));

  if (isPublic) return next(req);

  const token = userState.token() || localStorage.getItem('token');

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req);
};
